export enum AuthMethodEnum {
    PASSWORD = 'password',
    GOOGLE = 'google'
}

export type AuthMethodType = {
    method: AuthMethodEnum.PASSWORD | AuthMethodEnum.GOOGLE
    methodData: { username?: string; password?: string; id_token?: string }
}

export enum AuthSliceNamesEnum {
    AUTH = 'auth',
    AUTH_LOGIN = 'auth/login',
    AUTH_LOGOUT = 'auth/logout'
}
